module.exports = __webpack_public_path__ + "img/9.c2b4230a.jpg";